import React from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link, Switch, Route, Redirect } from 'react-router-dom';
import ProductCta from '../../components/ProductCta/ProductCta';
import ProductCtaBar from '../../components/ProductCta/ProductCtaBar';
import './rowerzysta/rowerzysta.scss';

const PURCHASE_URL = 'https://ubestrefa.pl/oferta/ZPYIGF';
const ICON_BASE = '/tvp/rowerzysta';

const coverageItems = [
  { src: `${ICON_BASE}/casco-roweru.svg`, title: 'Casco roweru' },
  { src: `${ICON_BASE}/bagaz-rowerzysty.svg`, title: 'Bagaż rowerzysty' },
  { src: `${ICON_BASE}/oc-rowerzysty.svg`, title: 'OC rowerzysty' },
  { src: `${ICON_BASE}/nnw-rowerzysty.svg`, title: 'NNW rowerzysty' },
  { src: `${ICON_BASE}/nnw-dziecka.png`, title: 'NNW dziecka (do 7 lat)' }
];

const DetailBlock = ({ title, illustration, children }) => (
  <section className="rowerzysta-detail">
    <header className="rowerzysta-detail-header">{title}</header>
    <div className="rowerzysta-detail-body">
      <div className="rowerzysta-detail-content">{children}</div>
      {illustration && (
        <div className="rowerzysta-detail-illustration">
          <img src={illustration} alt="" />
        </div>
      )}
    </div>
  </section>
);

const Opis = () => (
  <>
    <section
      className="rowerzysta-hero"
      style={{ backgroundImage: "url('/tvp/rowerzysta/hero.jpg')" }}
      role="img"
      aria-label="Rowerzystka na polnej drodze">
      <div className="rowerzysta-hero-logo">
        <img src="/tvp/pzu_logo.png" alt="PZU" />
      </div>
      <div className="rowerzysta-hero-content">
        <div className="rowerzysta-hero-eyebrow">PZU Rowerzysta</div>
        <h1 className="rowerzysta-hero-title">
          Twój styl, Twoja trasa.
          <br />I spokój po drodze.
        </h1>
        <div className="rowerzysta-hero-cta">
          <ProductCta href={PURCHASE_URL}>Oblicz składkę</ProductCta>
        </div>
      </div>
    </section>

    <p className="rowerzysta-lead">
      <strong>PZU Rowerzysta</strong> to ubezpieczenie, które może chronić
      Ciebie i Twój rower – niezależnie od tego, czy dojeżdżasz rowerem do
      pracy, czy poruszasz się nim rekreacyjnie. Może obejmować m.in.
      zniszczenie, uszkodzenie lub utratę roweru, odpowiedzialność cywilną wobec
      innych uczestników ruchu oraz wsparcie w razie trwałego uszczerbku na
      zdrowiu po nieszczęśliwym wypadku.
    </p>

    <div className="rowerzysta-coverage-band">
      <h2>Możesz wybrać ubezpieczenie:</h2>
      <div className="rowerzysta-coverage">
        {coverageItems.map((item) => (
          <div key={item.title} className="rowerzysta-coverage-card">
            <div className="rowerzysta-coverage-card-icon">
              <img src={item.src} alt="" />
            </div>
            <p className="rowerzysta-coverage-card-title">{item.title}</p>
          </div>
        ))}
      </div>
    </div>

    <h2 className="rowerzysta-section-heading">
      PZU Rowerzysta – jaką pomoc możesz otrzymać?
    </h2>
    <br />
    <DetailBlock
      title="Casco roweru"
      illustration={`${ICON_BASE}/casco-roweru.svg`}>
      <p>
        Możemy wypłacić odszkodowanie za uszkodzenie, zniszczenie albo utratę
        roweru (w tym jego wyposażenia) lub urządzenia służącego do przewozu
        dzieci (np. przymocowanego fotelika lub przyczepki) spowodowane:
      </p>
      <ul>
        <li>zdarzeniem losowym (np. powódź, ogień),</li>
        <li>wypadkiem rowerowym (np. zderzeniem z innym rowerzystą),</li>
        <li>rabunkiem,</li>
        <li>
          kradzieżą z usunięciem zabezpieczeń (np. roweru przypiętego do stojaka
          pod blokiem),
        </li>
        <li>kradzieżą z włamaniem (np. z wózka czy samochodu),</li>
        <li>dewastacją lub przepięciem.</li>
      </ul>
    </DetailBlock>

    <DetailBlock
      title="Bagaż rowerzysty"
      illustration={`${ICON_BASE}/bagaz-rowerzysty.svg`}>
      <p>
        Możemy wypłacić odszkodowanie za utratę, uszkodzenie lub zniszczenie
        bagażu przewożonego rowerem (np. narzędzi rowerowych w sakwie czy
        odzieży i kasku, które masz na sobie), spowodowane:
      </p>
      <ul>
        <li>zdarzeniem losowym (np. powódź, ogień),</li>
        <li>wypadkiem rowerowym (np. zderzeniem z innym rowerzystą),</li>
        <li>rabunkiem.</li>
      </ul>
    </DetailBlock>

    <DetailBlock
      title="OC rowerzysty"
      illustration={`${ICON_BASE}/oc-rowerzysty.svg`}>
      <p>
        Możemy wypłacić odszkodowanie osobie, której niechcący wyrządzisz szkodę
        w związku z posiadaniem lub użytkowaniem roweru, np. gdy przez nieuwagę
        porysujesz czyjeś auto lub potrącisz przechodnia.
      </p>
    </DetailBlock>

    <DetailBlock
      title="NNW rowerzysty"
      illustration={`${ICON_BASE}/nnw-rowerzysty.svg`}>
      <p>
        Jeśli podczas jazdy rowerem dojdzie do nieszczęśliwego wypadku, możesz
        otrzymać wsparcie finansowe:
      </p>
      <ul>
        <li>świadczenie w razie trwałego uszczerbku na zdrowiu,</li>
        <li>zwrot kosztów leczenia,</li>
        <li>
          świadczenie za leczenie uciążliwe (tj. leczenie, które wymagało
          operacji chirurgicznej lub hospitalizacji trwającej minimum 5 dni).
        </li>
      </ul>
      <p>
        W razie Twojej śmierci możemy wypłacić świadczenie osobom uposażonym.
      </p>
      <p>
        W ramach ubezpieczenia NNW rowerzysty możesz korzystać z usług{' '}
        <strong>assistance</strong> na terenie Polski. Dzięki temu w określonych
        przypadkach (np. jeśli w Polsce zderzysz się z innym rowerzystą i
        złamiesz nogę) możemy zorganizować dla Ciebie i opłacić m.in.:
      </p>
      <ul>
        <li>wizyty lekarza,</li>
        <li>wizyty pielęgniarki,</li>
        <li>transport medyczny,</li>
        <li>pomoc rehabilitacyjną i pielęgnacyjną,</li>
        <li>pomoc psychologa.</li>
      </ul>
    </DetailBlock>

    <DetailBlock
      title="NNW dziecka (do 7 lat)"
      illustration={`${ICON_BASE}/nnw-dziecka.png`}>
      <p>
        Dodatkowo możesz ubezpieczyć <strong>dziecko (do 7 lat)</strong>, które
        podróżuje rowerem z Tobą – w foteliku lub w przyczepce rowerowej. Dzięki
        temu, jeśli podczas jazdy dojdzie do nieszczęśliwego wypadku, możemy
        wypłacić świadczenie również w razie uszczerbku na zdrowiu dziecka.
      </p>
    </DetailBlock>

    <div className="rowerzysta-extras">
      <h3>Dodatkowe opcje</h3>
      <ul>
        <li>
          Ochrona może obejmować również udział{' '}
          <strong>w zawodach amatorskich</strong>.
        </li>
        <li>
          Zakres terytorialny PZU Rowerzysta możesz{' '}
          <strong>rozszerzyć na cały świat</strong>.
        </li>
      </ul>
    </div>

    <aside className="rowerzysta-notice">
      <h3 className="rowerzysta-notice-title">Uwaga!</h3>
      <ul>
        <li>
          Dokumenty potwierdzające zakup roweru (paragon lub faktura) nie mogą
          być <strong>starsze niż cztery lata</strong> od daty zakupu polisy.
        </li>
        <li>
          Istotne jest również{' '}
          <strong>odpowiednie zabezpieczenie roweru</strong> przed kradzieżą –
          np. przechowywanie w zamkniętym pomieszczeniu albo stosowanie blokady
          czy linki zabezpieczającej.
        </li>
      </ul>
    </aside>

    {/* <h2 className="rowerzysta-section-heading">Jak kupić ubezpieczenie?</h2>
    <br /> */}

    {/* <div className="rowerzysta-steps">
      <div className="rowerzysta-steps-item">
        <div className="rowerzysta-steps-item-number">1</div>
        <p>
          Skontaktuj się z nami w dogodny dla Ciebie sposób: odwiedź agenta lub
          oddział PZU, albo zadzwoń na infolinię{' '}
          <strong>801&nbsp;102&nbsp;102</strong> (opłata zgodna z taryfą
          operatora).
        </p>
      </div>
      <div className="rowerzysta-steps-item">
        <div className="rowerzysta-steps-item-number">2</div>
        <p>
          Od agenta, pracownika oddziału lub konsultanta infolinii otrzymasz{' '}
          <strong>kod oferty</strong>. Wejdź na stronę{' '}
          <strong>ubestrefa.pl</strong> i kup ubezpieczenie.
        </p>
        <div className="rowerzysta-steps-item-art">
          <img src={`${ICON_BASE}/ubestrefa-laptop.png`} alt="ubestrefa.pl" />
        </div>
      </div>
      <div className="rowerzysta-steps-item">
        <div className="rowerzysta-steps-item-number">3</div>
        <p>
          Gdy zawrzesz umowę i opłacisz składkę, otrzymasz polisę e-mailem (na
          adres, który wskażesz w formularzu przy zakupie ubezpieczenia).
        </p>
      </div>
    </div> */}

    <div className="rowerzysta-cta">
      <div>
        <h3>Gotowy na obliczenie składki?</h3>
        <p>
          Przejdź do bezpiecznej strony zakupu PZU Rowerzysta na ubestrefa.pl.
        </p>
        <ProductCta href={PURCHASE_URL}>Oblicz składkę</ProductCta>
      </div>
    </div>

    <div className="rowerzysta-disclaimer">
      Zakładem ubezpieczeń jest PZU SA. Ten materiał nie jest ofertą w
      rozumieniu art. 66 Kodeksu cywilnego i ma charakter wyłącznie
      informacyjny. Szczegółowe informacje o zakresie ubezpieczenia, w tym o
      wyłączeniach i ograniczeniach odpowiedzialności, znajdziesz w aktualnych
      ogólnych warunkach ubezpieczenia (OWU) PZU Rowerzysta – dostępnych u
      naszych agentów, w naszych oddziałach i na pzu.pl.
    </div>
  </>
);

const Rowerzysta = (props) => {
  const basePath = props.match.path;

  return (
    <div className="rowerzysta-shell">
      <Breadcrumb>
        <BreadcrumbItem>
          <Link to="/">{props.rootSection}</Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link to={basePath}>{props.section}</Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>Opis</BreadcrumbItem>
      </Breadcrumb>

      <Switch>
        <Route path={`${basePath}opis/`} component={Opis} />
        <Redirect exact from={basePath} to={`${basePath}opis/`} />
      </Switch>

      <ProductCtaBar title="PZU Rowerzysta">
        <ProductCta href={PURCHASE_URL}>Oblicz składkę</ProductCta>
      </ProductCtaBar>
    </div>
  );
};

export default Rowerzysta;
